/** Canonical project-lineage panel used by V4, embed, and legacy docking hosts. */

import { useProvenanceContext } from "../../context/ProvenanceContext";
import { DagViewerSurface } from "../../features/dag-viewer";

interface Props {
  projectId: string;
}

export default function DAGPanel({ projectId }: Props) {
  const {
    currentBranch,
    selectedArtifactId,
    selectArtifact,
    selectArtifactAndOpenPanel,
  } = useProvenanceContext();

  return (
    <div data-tour="dag-panel" style={{ display: "flex", height: "100%", minHeight: 0 }}>
      <DagViewerSurface
        projectId={projectId}
        projectName="Project lineage"
        branch={currentBranch}
        selectedNodeId={selectedArtifactId}
        onSelectNode={selectArtifact}
        onActivateNode={(nodeId) => selectArtifactAndOpenPanel(nodeId, "detail")}
        variant="embedded"
      />
    </div>
  );
}
